import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { pickDataAttributes } from '../../utils/pickDataAttributes/pickDataAttributes';
// styles
import { BreadcrumbsNavStyled, BreadcrumbsStyled } from './breadcrumbs.styled';
import { CrumbStandAlone } from './components/crumbStandAlone';
import { crumbMaxCharName } from './utils/crumbMaxCharName';
import useIsOverflow from './utils/useIsOverflow';
const BreadcrumbsStandAloneComponent = ({ id, dataTestId = 'breadcrumbs', crumbs, styles, minCharLimit = 20, lastOneCrumbComponent, ...props }, ref) => {
    const { innerRef, isOverflow } = useIsOverflow();
    const dataAttributes = pickDataAttributes(props);
    return (_jsx(BreadcrumbsStyled, { ...dataAttributes, ref: ref, "data-testid": dataTestId, id: id, children: _jsx(BreadcrumbsNavStyled, { ref: innerRef, "aria-label": props['aria-label'], children: _jsx("ol", { children: crumbs?.length &&
                    crumbs.map((crumb, index) => {
                        const lastCrumb = index + 1 === crumbs.length;
                        return (_jsx(CrumbStandAlone, { crumb: crumbMaxCharName(crumb, minCharLimit, isOverflow, lastCrumb), dataTestId: `${dataTestId}-${index}`, dividerIcon: props.dividerIcon, lastCrumb: lastCrumb, lastOneCrumbComponent: lastOneCrumbComponent, link: props.link, styles: styles, ...crumb }, crumb.name));
                    }) }) }) }));
};
export const BreadcrumbsStandAlone = React.forwardRef(BreadcrumbsStandAloneComponent);
//# sourceMappingURL=breadcrumbsStandAlone.js.map